import * as React from "react";
import { WavePlayer } from "./aktueller-podcast";
import { uiRegistry } from "../utils/ui-registry";
import { Footer } from "./footer";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import GatsbyImage from "gatsby-image";
import { MaxWidth, maxMedia, theme } from "../utils/style";

export const Layout = React.forwardRef(({ children, ...props }: any, ref: any) => {
  React.useEffect(() => {
    const isIE11 = eval("!!window.MSInputMethodContext && !!document.documentMode");
    if (isIE11) return;
    // window.dispatchEvent(new Event("resize"));
  });

  const data = useStaticQuery(graphql`
    {
      file(relativePath: { eq: "cmc.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <GlobalWrap {...props} ref={ref}>
      {children}

      <Footer />
    </GlobalWrap>
  );
});

const GlobalWrap = styled.div`
  a {
    font-weight: bold;
    &:not(.none) {
      color: ${theme.primaryColor};
    }

    &.white {
      color: white;
    }

    &.inherit {
      color: inherit;
    }
  }
`;

